import { FunctionComponent } from 'react';
import { InvoicingAccountCard } from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { InvoicingAccountOptionResponseContents, UserGroupResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';
import { UserResponseWithUserGroup } from '../../utils';

interface InvoicingAccountsProps {
  userOrUserGroup: UserResponseWithUserGroup | UserGroupResponse;
  invoicingAccounts: InvoicingAccountOptionResponseContents[];
  updateInvoicingAccount: ({ invoicing_account }: { invoicing_account?: string | null }) => Promise<boolean>;
}

const InvoicingAccounts: FunctionComponent<InvoicingAccountsProps> = ({ userOrUserGroup, invoicingAccounts, updateInvoicingAccount }) => {
  const { t } = useTranslation('invoicingAccount');

  return (
    <InvoicingAccountCard
      translations={{
        title: t('invoicingAccounts.title'),
        overrideCheckboxLabel: t('invoicingAccounts.overrideCheckboxLabel'),
        invoicingAccountDropdownLabel: t('invoicingAccounts.invoicingAccountDropdownLabel'),
        accountNotValidTitle: t('invoicingAccounts.accountNotValidTitle'),
        accountNotValidMessage: t('invoicingAccounts.accountNotValidMessage'),
        userGroupAccountNotValidMessage: t('invoicingAccounts.userGroupAccountNotValidMessage'),
        accountNotValidLabel: t('invoicingAccounts.accountNotValidLabel'),
        saveButton: t('invoicingAccounts.saveButton'),
        cancelButton: t('invoicingAccounts.cancelButton'),
        noInvoicingAccountsInfo: t('invoicingAccounts.noInvoicingAccountsInfo'),
        saveErrorTitle: t('invoicingAccounts.saveErrorTitle'),
        saveErrorMessage: t('invoicingAccounts.saveErrorMessage'),
        dropdownHelperText: t('invoicingAccounts.dropdownHelperText'),
      }}
      invoicingAccounts={invoicingAccounts}
      userOrUserGroup={userOrUserGroup}
      submitValues={updateInvoicingAccount}
    />
  );
};

export default InvoicingAccounts;
